import FormattedMessage from 'I18n/components/FormattedMessage';
import { GET_AUTOMATED_EMAILS_BY_IDS, getAutomatedEmails } from 'automation-ui-action-fields/automated-emails/emailQueries';
import { useQuery } from 'data-fetching-client';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const AutomatedEmailName = ({
  emailId,
  sourceApp
}) => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_AUTOMATED_EMAILS_BY_IDS, {
    skip: !emailId || Number.isNaN(+emailId),
    variables: {
      emailId,
      sourceApp
    }
  });
  if (error || Number.isNaN(+emailId)) {
    return /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-50",
      color: "text-alert-default",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-action-features.automated-emails.automated-email-name.loading-error"
      })
    });
  }
  const [firstEmail] = getAutomatedEmails(data) || [];
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !loading && firstEmail && firstEmail.name
  });
};
export default AutomatedEmailName;